import type { FetchReferrerDto } from '@repo/api';
import {
  type ApiParamReaders,
  pickApiParams,
  SEARCH_AND_SORT_PARAMS,
  valueParam,
} from '@/lib/helpers/list-api-params';
import {
  ACTIVE_STATUS_DEFAULT_TAB,
  ACTIVE_STATUS_TABS,
} from '@/lib/helpers/list-tabs';
import type { ReferrersSearch } from '@/routes/-shared/referrersSearchSchema';

export const REFERRERS_DEFAULT_TAB = ACTIVE_STATUS_DEFAULT_TAB;

/** Tab della lista: lo stato attivo, comune alle liste con `isActive`. */
export const REFERRERS_TABS = ACTIVE_STATUS_TABS;

type ReferrersApiParams = Omit<FetchReferrerDto, 'skip' | 'take'>;

/**
 * Campi di `GET backoffice/referrers`: ricerca, ordinamento, tipo (validato
 * dallo schema della rotta) e rivenditore. Lo stato arriva dal tab.
 */
const REFERRERS_API_PARAMS: ApiParamReaders<
  ReferrersSearch,
  ReferrersApiParams
> = {
  ...SEARCH_AND_SORT_PARAMS,
  type: valueParam,
  parentId: valueParam,
};

export function buildReferrersApiParams(
  search: ReferrersSearch,
  isActive: boolean | undefined
): ReferrersApiParams {
  return { ...pickApiParams(search, REFERRERS_API_PARAMS), isActive };
}

/**
 * Le due viste della pagina: la rete raggruppata per commerciale (design
 * «Rete commerciale», default) e l'elenco con filtri e azioni di riga.
 */
export const REFERRERS_VIEWS = ['network', 'list'] as const;
export type ReferrersView = (typeof REFERRERS_VIEWS)[number];
export const REFERRERS_DEFAULT_VIEW: ReferrersView = 'network';
